import {
    GET_MODULES_ERROR,
    GET_MODULES_SUCCESS
    } from "../../actionTypes/authActionTypes";
    import initialState from "../../store/initialState";
    
    const reducer = (state = initialState, action) => {
      switch (action.type) {
        case GET_MODULES_SUCCESS:
          return {
            ...state,
            allModulesData: action.payload,
          };
        case GET_MODULES_ERROR:
          return {
            ...state,
            coursesError: action.payload,
          };
        default:
          return state;
      }
    };
    
    export default reducer;
    